import React, { FC } from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Nav } from 'reactstrap';
import { PageHeader, UserStateComponent } from '../../../components';
import { useTranslation } from '../../../translations';
import { useConvention } from '../../../utils';
import { Dashboard } from './dashboard';
import { HotelList } from './hotels';
import {
  CreateReleaseGroupForm,
  EditReleaseGroupForm,
  ReleaseGroupList,
} from './releasegroups/ReleaseGroupList';
import { ReleaseGroupView } from './releasegroups/ReleaseGroupView';
import { Reservations } from './reservations';
import { ViewUserReservation } from './user';

export const HotelContainer: FC<RouteComponentProps> = ({ match: { path, url } }) => {
  const { hotelsEnabled } = useConvention();
  const { ts } = useTranslation();

  if (!hotelsEnabled) {
    return <Redirect to="/housekeeping" />;
  }

  return (
    <UserStateComponent>
      <PageHeader>{ts('common.hotel_management')}</PageHeader>

      <Nav tabs>
        <NavLink activeClassName="active" className="nav-link" exact to={url}>
          {ts('home')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/hotels`}>
          {ts('hotels')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/groups`}>
          {ts('release_groups')}
        </NavLink>
        <NavLink activeClassName="active" className="nav-link" to={`${url}/reservations`}>
          {ts('reservations')}
        </NavLink>
      </Nav>

      <div style={{ marginTop: '20px' }}>
        <Switch>
          <Route component={Dashboard} exact path={path} />
          <Route component={HotelList} exact path={`${path}/hotels`} />
          <Route component={ReleaseGroupList} exact path={`${path}/groups`} />
          <Route component={Reservations} exact path={`${path}/reservations`} />
          <Route component={ViewUserReservation} exact path={`${path}/user/:id`} />
          <Route component={CreateReleaseGroupForm} path={`${path}/groups/new`} />
          <Route component={EditReleaseGroupForm} path={`${path}/groups/:id/edit`} />
          <Route component={ReleaseGroupView} path={`${path}/groups/:id/view`} />
        </Switch>
      </div>
    </UserStateComponent>
  );
};
